import RollerLoading from './RollerLoading';

export default RollerLoading;



// WEBPACK FOOTER //
// ./src/shared/components/rollerLoading/index.ts